export default __webpack_public_path__ + "static/Montserrat-Light-4d69695c696b3bc4cc856eafbfb10026.woff";